/*
 * File: DetailPagePanel.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: July 21, 2025 at 1:29 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 300px;
	height: 100%;
	margin: ${({ $offset }) => `${$offset}px 0px 0px`};
	flex-shrink: 0;

	padding: 0px 0px 0px 18px;
	& > div:not(:last-child) {
		border-bottom: 1px solid ${({ theme }) => theme.layoutBorder};
	}
	& > div:not(:first-child) {
		margin: 20px 0px 0px;
	}
`;

export const ContentSection = styled.div`
	padding: 0px 0px 20px;

	h3 {
		font-size: 1.3rem;
		margin: 0px 0px 4px;
	}
	p {
		font-size: 0.96rem;
		line-height: 150%;
		color: ${({ theme }) => theme.secondaryText};
	}
	span {
		font-size: 0.85rem;
	}
	button {
		width: 100%;
	}
`;

export const RelatedSection = styled.div`
	padding: 0px 0px 20px;

	h3 {
		font-size: 1.3rem;
		margin: 0px 0px 4px;
	}
`;

export const RelatedContainer = styled.div`
	margin: 10px 0px 0px;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;

	p {
		text-align: left;
		font-size: 0.9rem;
	}
`;

export const RelatedPlaceholder = styled.div``;

export const ResourcesSection = styled.div`
	padding: 0px 0px 20px;
	display: flex;
	flex-direction: column;
	gap: 10px;

	span {
		font-size: 0.85rem;
	}
	button {
		width: 100%;
	}
`;

export const MetricsSection = styled.div`
	padding: 0px 0px 20px;
	border-bottom: 1px solid ${({ theme }) => theme.layoutBorder};
	margin: 20px 0px 0px;
`;

export const ReactionBadge = styled(FontAwesomeIcon)`
	color: ${({ theme }) => theme.brandHighlight};
	margin: 0px 0px 0px 4px;
	font-size: 0.8rem;
	transform: scale(1);

	&.animatePulse {
   		animation: pulse 0.8s;
	}
	@keyframes pulse {
		0% {
			transform: scale(1);
		}
		40% {
			transform: scale(1.3);
		}
		100% {
			transform: scale(1);
		}
	}
`;

export const FooterSection = styled.div`
	p {
		margin: 0px 0px 6px;
		color: ${({ theme }) => theme.secondaryText};
	}
	span {
		font-size: 0.85rem;
	}
	button {
		width: 100%;
		margin: 0px 0px 10px;
	}
`;

export const MetricContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 29px;
	margin: 0px 0px 6px;
`;

export const Metric = styled.div`
	p {
		font-size: 1.0rem !important;
	}
	p:last-child {
		margin-top: -5px;
		color: ${({ theme }) => theme.secondaryText};
		font-size: 0.9rem !important;
	}
	p:first-child {
		min-width: 40px;

		&.shimmer-element {
			position: relative;
			top: -3px;
		}
	}
`;

export const PrimaryResource = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
